import mainCaller from "./mainCaller";

// force=true 는 상담이 낀 일정 겹침을 사용자가 확인한 뒤 다시 보낼 때만 쓴다(withOverlapConfirm)
export const createLesson = async (data, token, force = false) => {
  return await mainCaller(`admin/api/v1/course/classes${force ? "?force=true" : ""}`, "POST", data, {
    Authorization: "Bearer " + token,
  });
};

// 그룹수업 생성 동시 예약 — 선택 수강권 상품을 보유한 유효 회원 후보. memberGroupId 로 그룹 소속만 좁힌다.
export const getGroupReserveCandidates = async ({ ticketIds, startDate, endDate, memberGroupId }, token) => {
  const params = new URLSearchParams();
  ticketIds.forEach(id => params.append("ticketIds", id));
  params.append("startDate", startDate);
  params.append("endDate", endDate);
  if (memberGroupId) params.append("memberGroupId", memberGroupId);
  return await mainCaller(`admin/api/v1/course/classes/group-reserve/candidates?${params.toString()}`, "GET", null, {
    Authorization: "Bearer " + token,
  });
};

// 그룹수업 생성 미리보기 — 회차 생성 검증 + 회원×회차 예약 가능 여부(저장 없음). 요청 본문은 createLesson 과 동일.
export const previewGroupReserve = async (data, token, force = false) => {
  return await mainCaller(`admin/api/v1/course/classes/group-reserve/preview${force ? "?force=true" : ""}`, "POST", data, {
    Authorization: "Bearer " + token,
  });
};

// 기존 그룹수업 × 여러 회원 일괄예약 — 기간(필수)·요일·시간대(선택)로 앞으로의 그룹수업 검색. 몇 개 예약할지는 프론트 선택 수.
export const getGroupBatchReserveClasses = async ({ branchId, startDate, endDate, dayOfWeeks, startTime, endTime }, token) => {
  const params = new URLSearchParams({ branchId, startDate, endDate });
  (dayOfWeeks || []).forEach(d => params.append("dayOfWeeks", d));
  if (startTime) params.append("startTime", startTime);
  if (endTime) params.append("endTime", endTime);
  return await mainCaller(`admin/api/v1/course/classes/group-batch-reserve/classes?${params.toString()}`, "GET", null, {
    Authorization: "Bearer " + token,
  });
};

// 선택 수업들에 매핑된 수강권을 보유한 후보 회원(+이미 예약 회차 수). memberGroupId 로 그룹 소속만.
export const getGroupBatchReserveCandidates = async (
  { courseClassIds, memberGroupId, courseTicketIds, trialTicketIds },
  token,
) => {
  const params = new URLSearchParams();
  courseClassIds.forEach(id => params.append("courseClassIds", id));
  if (memberGroupId) params.append("memberGroupId", memberGroupId);
  (courseTicketIds || []).forEach(id => params.append("courseTicketIds", id));
  (trialTicketIds || []).forEach(id => params.append("trialTicketIds", id));
  return await mainCaller(`admin/api/v1/course/classes/group-batch-reserve/candidates?${params.toString()}`, "GET", null, {
    Authorization: "Bearer " + token,
  });
};

// 회원×수업 판정(저장 없음). body = {courseClassIds, memberIds}
export const previewGroupBatchReserve = async (data, token) => {
  return await mainCaller("admin/api/v1/course/classes/group-batch-reserve/preview", "POST", data, {
    Authorization: "Bearer " + token,
  });
};

// 일괄예약 실행. 통과 회원만 예약, 앱 알림 없음.
export const createGroupBatchReserve = async (data, token) => {
  return await mainCaller("admin/api/v1/course/classes/group-batch-reserve", "POST", data, {
    Authorization: "Bearer " + token,
  });
};

export const getAllLessonsByType = async (data, token) => {
  return await mainCaller(`admin/api/v1/course/classes?${data}`, "GET", null, {
    Authorization: "Bearer " + token,
  });
};

export const updateLesson = async (data, token, force = false) => {
  return await mainCaller(`admin/api/v1/course/classes/${data.courseClassId}${force ? "?force=true" : ""}`, "PUT", data, {
    Authorization: "Bearer " + token,
  });
};

export const bulkUpdateLessons = async (data, token, force = false) => {
  return await mainCaller(`admin/api/v1/course/classes/bulk-update${force ? "?force=true" : ""}`, "PUT", data, {
    Authorization: "Bearer " + token,
  });
};

export const bulkDeleteLessons = async (data, token) => {
  return await mainCaller("admin/api/v1/course/classes/bulk-delete", "PUT", data, {
    Authorization: "Bearer " + token,
  });
};

export const getCourseClassTimeMembers = async (courseClassTimeId, token) => {
  return await mainCaller(
    `admin/api/v1/course/classes/times/${courseClassTimeId}/members`,
    "GET",
    null,
    { Authorization: "Bearer " + token },
  );
};

export const copyLessonsToNextWeek = async (data, token) => {
  return await mainCaller("admin/multiCreateLesson", "POST", data, {
    Authorization: "Bearer " + token,
  });
};

// 스케줄 붙여넣기 사전확인(#143) — 대상 강사가 회원 수강권의 그 지점 담당강사인지 본다(읽기 전용).
export const checkPasteTrainer = async (data, token) => {
  return await mainCaller("admin/api/v1/course/classes/paste/trainer-check", "POST", data, {
    Authorization: "Bearer " + token,
  });
};

// 듀엣 상대 — 이 회원과 이 듀엣 상품을 묶음 결제로 같이 산 회원(본인 제외). 없으면 빈 배열.
export const getDuetPartners = async (ticketId, memberId, token) => {
  return await mainCaller(
    `admin/api/v1/course/classes/duet-partners?ticketId=${ticketId}&memberId=${encodeURIComponent(memberId)}`,
    "GET",
    null,
    { Authorization: "Bearer " + token },
  );
};

export const getLessonById = async (id, token) => {
  return await mainCaller(`admin/api/v1/course/classes/${id}`, "GET", null, {
    Authorization: "Bearer " + token,
  });
};

export const getLessonsByType = async (type, token) => {
  return await mainCaller(`admin/getLessonByType/${type}`, "GET", null, {
    Authorization: "Bearer " + token,
  });
};

export const deleteLessonById = async (id, token) => {
  return await mainCaller(`admin/deleteLessonById/${id}`, "GET", null, {
    Authorization: "Bearer " + token,
  });
};

export const deleteWeekById = async (id, token) => {
  return await mainCaller(`admin/api/v1/course/classes/times/${id}`, "DELETE", null, {
    Authorization: "Bearer " + token,
  });
};

export const deleteWeekByIdAndType = async (data, token) => {
  return await mainCaller(`admin/api/v1/course/classes/times/type`, "DELETE", data, {
    Authorization: "Bearer " + token,
  });
};

export const searchBatchReservationLessons = async (params, token) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (key === 'dayOfWeeks' && value) {
      // dayOfWeeks는 배열로 처리 (Spring에서 List로 받기 위해)
      const days = value.split(',');
      days.forEach(day => {
        searchParams.append('dayOfWeeks', day.trim());
      });
    } else if (value !== undefined && value !== null && value !== '') {
      searchParams.append(key, value);
    }
  });

  return await mainCaller(`admin/api/v1/course/classes/batch-reservation/search?${searchParams.toString()}`, "GET", null, {
    Authorization: "Bearer " + token,
  });
};

export const createBatchReservation = async (data, token, force = false) => {
  return await mainCaller(`admin/api/v1/course/classes/batch-reservation${force ? "?force=true" : ""}`, "POST", data, {
    Authorization: "Bearer " + token,
  });
};

// 개인레슨 일괄 생성 프리뷰 — 요일/시간으로 예약기간 동안 생성될 후보 세션 목록을 미리 받는다.
export const getPrivateBatchPreview = async (data, token) => {
  return await mainCaller("admin/api/v1/course/classes/private-batch/preview", "POST", data, {
    Authorization: "Bearer " + token,
  });
};

// 개인레슨 일괄 생성 — 프리뷰에서 선택된 세션만 실제 생성한다.
export const createPrivateBatch = async (data, token) => {
  return await mainCaller("admin/api/v1/course/classes/private-batch", "POST", data, {
    Authorization: "Bearer " + token,
  });
};

// ============================================
// 그룹레슨 템플릿 API
// ============================================

export const getGroupLessonTemplates = async (branchId, token, page = 1, limit = 10) => {
  return await mainCaller(`admin/api/v1/group-lesson/templates?branchId=${branchId}&page=${page}&limit=${limit}`, "GET", null, {
    Authorization: "Bearer " + token,
  });
};

export const getGroupLessonTemplateById = async (id, token) => {
  return await mainCaller(`admin/api/v1/group-lesson/templates/${id}`, "GET", null, {
    Authorization: "Bearer " + token,
  });
};

export const createGroupLessonTemplate = async (data, token) => {
  return await mainCaller("admin/api/v1/group-lesson/templates", "POST", data, {
    Authorization: "Bearer " + token,
  });
};

export const updateGroupLessonTemplate = async (id, data, token) => {
  return await mainCaller(`admin/api/v1/group-lesson/templates/${id}`, "PUT", data, {
    Authorization: "Bearer " + token,
  });
};

export const deleteGroupLessonTemplate = async (id, token) => {
  return await mainCaller(`admin/api/v1/group-lesson/templates/${id}`, "DELETE", null, {
    Authorization: "Bearer " + token,
  });
};

// 템플릿에 연결된 미래 수업 목록 조회
export const getTemplateLinkedClasses = async (id, token) => {
  return await mainCaller(`admin/api/v1/group-lesson/templates/${id}/classes`, "GET", null, {
    Authorization: "Bearer " + token,
  });
};
